import publicAxios, { API_URL } from './PublicAxios';

/**
 * Chamadas públicas da contratação de plano pelo ambiente de agendamento. Sem login do
 * sistema: o cliente confirma o e-mail por código e a sessão vai no mesmo cabeçalho do Clube.
 */

const headers = (token) => ({ 'X-Club-Token': token });

/** O menu de planos só aparece quando isto responde enabled (empresa com provedor de pagamento). */
export const getPlanSignupStatus = (company) => publicAxios.get(`/api/booking/${company}/plan-signup/status`);
export const getPlanOffers = (company) => publicAxios.get(`/api/booking/${company}/plan-signup/plans`);
export const requestPlanSignupCode = (company, document) => publicAxios.post(`/api/booking/${company}/plan-signup/auth/code`, { document });
export const verifyPlanSignupCode = (company, document, code) => publicAxios.post(`/api/booking/${company}/plan-signup/auth/verify`, { document, code });
// contractReference identifica o texto que o cliente leu; o backend recusa se ele mudou desde então.
export const subscribeToPlan = (company, token, planUuid, contractReference) => publicAxios.post(
    `/api/booking/${company}/plan-signup/plans/${planUuid}/subscribe`, { contractReference }, { headers: headers(token) });

/** Endereço do PDF do contrato do plano (aberto em nova aba; é público por plano). */
export const planContractUrl = (company, planUuid) => `${API_URL}/api/booking/${company}/plans/${planUuid}/contract`;
